import React from 'react';
import AddToCartButton from '../shared/AddToCartButton';

const Product = ({ Name, Price, Quantity, ImageUrl, Url, Code, addToCartEndpoint, translationUtility, IsStopWorkshop }) => {

    return (
        <div className="col-md-12 col-lg-6 product-container">
            <div className="card mb-4">
                <div className="row product-tile">
                    <div className="col-12 col-lg-4 reorder-image">
                        <a href={Url} title={Name}>
                            <img src={ImageUrl} alt={Name} className="item-img img-fluid"/>
                        </a>
                    </div>
                    <div className="col-12 col-lg-8">
                        <a href={Url} title={Name}><h4 className="headline headline-xs">{Name}</h4></a>
                        <div className="product-price text-sm fw-600">{Price}</div>
                        {!IsStopWorkshop && (
                            <div className="product-quantity text-sm">{translationUtility.translateResourceString('/Reorder/QuantityLabel')}: {Quantity}</div>
                        )}
                        <div>
                            <AddToCartButton
                                code={Code}
                                addToCartEndpoint={addToCartEndpoint}
                                quantity={Quantity}
                                text={translationUtility.translateResourceString("/Reorder/ReorderButton")}
                            ></AddToCartButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Product;
